<template>
  <div class="payment-config-step">
    <div v-if="isLoading" class="loading-state">
      <spinner />
    </div>

    <FranchisesSubaccountsConfigForm
      v-else
      ref="formRef"
      :account-id="accountId ?? undefined"
      :config-data="configData ?? undefined"
      @validate="handleValidation"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { log } from '@/utils/DebugLogger';
import FranchisesSubaccountsConfigForm from './FranchisesSubaccountsConfigForm.vue';

type Id = number | string;

interface Props {
  accountId?: Id | null;
  configData?: Record<string, unknown> | null;
}

interface FormInstance {
  validate?: () => boolean;
  getFormData?: () => Record<string, unknown> | null;
}

const props = withDefaults(defineProps<Props>(), {
  accountId: null,
  configData: null
});

const emit = defineEmits<{
  validate: [isValid: boolean];
}>();

// State
const isLoading = ref<boolean>(false);
const formRef = ref<FormInstance | null>(null);

// Methods
const handleValidation = (isValid: boolean): void => {
  emit('validate', isValid);
};

const validate = (): boolean => {
  return formRef.value?.validate?.() ?? false;
};

const getFormData = (): Record<string, unknown> | null => {
  return formRef.value?.getFormData?.() ?? null;
};

// Lifecycle
onMounted(() => {
  log('FranchisesConfigStep', 'onMounted', 'Component mounted', { accountId: props.accountId });
});

// Expose methods for parent
defineExpose({
  validate,
  getFormData
});
</script>

<style scoped>
.payment-config-step {
  min-height: 200px;
}

.loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}
</style>
